/* eslint-disable */
import { createSlice } from "@reduxjs/toolkit";

import { setMiddleWareOrderAsync } from "@components/OrderTaking/Store/feature/thunksMiddlware";

const initialState = {
    middleWareOrder: {},
    loading: false,
    error: null,
};

export const middlwareOrderSlice = createSlice({
    name: "middlwareOrderSlice",
    initialState,
    reducers: {
        clearMiddlwareOrder: (state) => {
            state.middleWareOrder = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setMiddleWareOrderAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
                // Clear previous middleware order
                state.middleWareOrder = {};
            })
            .addCase(setMiddleWareOrderAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.middleWareOrder = action.payload;
            })
            .addCase(setMiddleWareOrderAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { clearMiddlwareOrder, setMiddlwareOrderRewards } =
    middlwareOrderSlice.actions;

export default middlwareOrderSlice.reducer;
